import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { MinuterieLabelComponent } from '../../../../../../../../components/ecosystems/minuterie-label/minuterie-label.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { convertMinutesToTime } from '../../../../../../helper/convertSecondsToTime';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { FunctionParametersSettingsWeltico2ClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-weltico2-clock-screen/function-parameters-settings-weltico2-clock-screen.component';
import { FunctionParametersSettingWeltico2ClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-weltico2-clock-week-screen/function-parameters-setting-weltico2-clock-week-screen.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';

@Component({
  selector: 'app-p00039-eclairage-parameters-settings',
  templateUrl: './p00039-eclairage-parameters-settings.component.html',
  styleUrls: ['./p00039-eclairage-parameters-settings.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    LargedLinkComponent,
    MinuterieLabelComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
    LabelDescriptionComponent,
  ],
})
export class P00039EclairageParametersSettingsComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  async goToFunctionParametersSettingsWeltico2ClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsWeltico2ClockScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourLundi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourMardi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourMercredi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourJeudi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourVendredi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourSamedi',
          ) +
          this.actionStack!.getValue(
            'eclairageStandardPHorlogeWelticoJourDimanche',
          ),
        colorType: this.actionStack!.getValue(
          'eclairageStandardITypeEclairage',
        ),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage4,
        'eclairageStandardPHorlogeWelticoJourLundi',
        hj.substring(0, 48),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage5,
        'eclairageStandardPHorlogeWelticoJourMardi',
        hj.substring(48, 96),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage5,
        'eclairageStandardPHorlogeWelticoJourMercredi',
        hj.substring(96, 144),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage6,
        'eclairageStandardPHorlogeWelticoJourJeudi',
        hj.substring(144, 192),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage6,
        'eclairageStandardPHorlogeWelticoJourVendredi',
        hj.substring(192, 240),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage7,
        'eclairageStandardPHorlogeWelticoJourSamedi',
        hj.substring(240, 288),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage7,
        'eclairageStandardPHorlogeWelticoJourDimanche',
        hj.substring(288, 336),
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingWeltico2ClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingWeltico2ClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue(
          'eclairageStandardPHorlogeWelticoSemaine',
        ),
        colorType: this.actionStack!.getValue(
          'eclairageStandardITypeEclairage',
        ),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage4,
        'eclairageStandardPHorlogeWelticoSemaine',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('eclairageStandardPHorlogeJour'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage,
        'eclairageStandardPHorlogeJour',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('eclairageStandardPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage,
        'eclairageStandardPHorlogeSemaine',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly convertMinutesToTime = convertMinutesToTime;
}
